// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar {
  --background: #fff; /* Ensure toolbar background is set */
}

ion-buttons {
  display: flex;
  align-items: center;
}

ion-menu-button {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/app/shaps/oneadmin/cashier/cashier.page.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA,EAAA,qCAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;AACF","sourcesContent":["ion-toolbar {\n  --background: #fff; /* Ensure toolbar background is set */\n}\n\nion-buttons {\n  display: flex;\n  align-items: center;\n}\n\nion-menu-button {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
